import * as React from "react";
import FormControl from "@mui/material/FormControl";
import {FormHelperText} from "@mui/material";
import {ReactNode, useEffect, useState} from "react";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import {convertToTranslationKeys, ValidationError} from "../../../services/validator";
import {useTranslation} from "react-i18next";

interface ISelectFieldProps {
    label: string;
    options: any[];
    value: any;
    onChange(value: any): void;
    optionValueGetter(option: any): any;
    optionLabelGetter(option: any): string | ReactNode;
    optionDisabledGetter?(option: any): boolean;
    errors?: ValidationError[];
}

export const SelectField = ({label, options, value, onChange, optionValueGetter, optionLabelGetter, optionDisabledGetter = () => false, errors}: ISelectFieldProps) => {
    const { t } = useTranslation();

    const [selected, setSelected] = useState<any>(value);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSelected(event.target.value);
    };

    useEffect(() => {
        setSelected(value);
    }, [value]);

    useEffect(() => {
        onChange(selected);
    }, [selected]);

    return (
        <FormControl fullWidth variant="outlined">
            <TextField
                select
                value={selected}
                onChange={handleChange}
                label={label}
                variant="outlined"
                error={!!errors && !!errors.length}
            >
                {options.map((option, i) => (
                    <MenuItem key={i} value={optionValueGetter(option)} disabled={optionDisabledGetter(option)}>
                        {optionLabelGetter(option)}
                    </MenuItem>
                ))}
            </TextField>

            {!!errors && !!errors.length &&
                <FormHelperText error>
                    {convertToTranslationKeys(errors).map(e => t(e)).join(', ')}
                </FormHelperText>
            }
        </FormControl>
    );
}
